import axios from "axios";

axios.interceptors.request.use((config) => {
    const tenantId = sessionStorage.getItem("TenantID");

    if (tenantId) {
        config.headers["TenantID"] = tenantId;
    }

    return config;
});

export default axios;